import { Injectable } from '../domain/di/injectable'
import { LocationRepository } from '../domain/location/location-repository'
import { Location } from '../domain/location/location'
import { Id } from '../domain/location/id'
import { LocationNotFoundError } from '../domain/location/location-not-found-error'
import { locationResponseLoader } from './location-loader'

const API_URL = "https://requests.mcoders.com/family/run"

@Injectable()
export class LocationRemoteRepository implements LocationRepository {
    private readonly locations = new Map<Id, Location>()
    
    
    async findAll(): Promise<Location[]> {
        const promise = new Promise((resolve, reject)=>{
            fetch(API_URL).then(response => {
                response.json().then(json=>{
                    const data = locationResponseLoader(json)
                    data.forEach(location => {
                        this.create(location)
                    })
                    resolve(Array.from(this.locations.values()))
                })
            })
        })
        return promise
    }   

    update(id: number, location: Partial<Location>): void {
        const oldLocation = this.locations.get(id)

        if (oldLocation === undefined) {
            throw new LocationNotFoundError()
        }

        const updatedLocation: Location = {
            ...oldLocation,
            ...location
        }

        this.locations.set(id, updatedLocation)
    }

    create(location: Location): void {
        this.locations.set(location.id, location)
    }
}
